/* tslint:disable */
/* eslint-disable */
/**
 * Agora Livestock API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.0 (v2)
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * * `requires_payment_method` - requires_payment_method * `requires_confirmation` - requires_confirmation * `requires_action` - requires_action * `processing` - processing * `canceled` - canceled * `succeeded` - succeeded
 * @export
 * @enum {string}
 */
export enum StripeSetupIntentStatusEnum {
    RequiresPaymentMethod = 'requires_payment_method',
    RequiresConfirmation = 'requires_confirmation',
    RequiresAction = 'requires_action',
    Processing = 'processing',
    Canceled = 'canceled',
    Succeeded = 'succeeded'
}



